<div kalDialogContent [formGroup]="form">

    <kal-form-field [kalTheme]="theme"
                    [kalLoading]="isZoneLoading('isSamePasswordAsCurrent')">
        <kal-input label="Mot de passe actuel"
                   [autocomplete]="false"
                   formControlName="oldPassword"
                   type="password">
        </kal-input>
    </kal-form-field>

    <kal-form-field [kalTheme]="theme"
                    class="gup-C-formFieldSize--bottomNull">
        <kal-input label="Nouveau mot de passe"
                   [autocomplete]="false"
                   formControlName="newPassword"
                   type="password"></kal-input>
    </kal-form-field>

    <p class="gup-U-color--red" *ngIf="form.get('newPassword').errors && form.get('newPassword').pristine">
        Le nouveau mot de passe doit avoir au moins 14 caractères avec 1 majuscule, 1 minuscule, 1 chiffre et un caractère spécial.
    </p>

    <ul class="gup-O-list -vertical gup-U-margin-bottom--small" [class.gup-U-color--white]="theme">
        <li class="gup-O-list__item" *ngFor="let error of newPasswordErrors | keyvalue">
            <kal-icon
                [class]="error.value.icon === 'close' ? 'gup-U-color--red' : 'gup-U-color--green'">{{ error.value.icon }}
            </kal-icon>
            {{ error.value.label }}
        </li>
    </ul>


    <kal-form-field [kalTheme]="theme"
                    class="gup-C-formFieldSize--bottomNull">
        <kal-input label="Confirmer votre nouveau mot de passe"
                   [autocomplete]="false"
                   formControlName="confirmPassword"
                   type="password"></kal-input>
    </kal-form-field>

    <p class="gup-U-color--red gup-U-margin-bottom--small" *ngIf="form.errors?.invalidmatchpassword">
        Votre confirmation ne correspond pas au nouveau mot de passe.
    </p>

</div>
